<!-- eslint-disable @angular-eslint/template/no-call-expression -->
@if (products$ | async; as products) {
  @if (products.length > 0) {
    <div
      lazyLoad
      (lazyLoad)="onFirstView()">
      @if (piece) {
        <idt-common-styles-render [styles]="piece.settings?.styles">
          @if (formatType === 'row') {
            <div
              class="hudson-wrapper"
              #hudsonWrapper
              [class.mobile]="isMobile">
              <div
                #swiper
                cmsSwiper
                class="swiper-container"
                [config]="swiperConfig">
                <div class="swiper-wrapper">
                  @for (product of products; track product.id) {
                    <div class="swiper-slide">
                      <div class="product-card">
                        <ng-container
                          [ngTemplateOutlet]="productLink"
                          [ngTemplateOutletContext]="{product}">
                        </ng-container>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
          @if (formatType === 'custom') {
            <div class="hudson-more-looks-container">
              <div class="hudson-custom hudson-more-looks">
                @for (product of products; track product.id) {
                  <div class="product-card hudson-more-looks-product">
                    <ng-container
                      [ngTemplateOutlet]="productLink"
                      [ngTemplateOutletContext]="{product}">
                    </ng-container>
                  </div>
                }
              </div>
            </div>
          }
          @if (formatType === 'mosaic') {
            <div class="hudson-mosaic">
              @for (product of products; track product.id) {
                <div class="product-card">
                  <ng-container
                    [ngTemplateOutlet]="productLink"
                    [ngTemplateOutletContext]="{product}">
                  </ng-container>
                </div>
              }
            </div>
          }
        </idt-common-styles-render>
      }
    </div>
  }
}

<ng-template
  #productLink
  let-product="product">
  <render-link
    class="image-link-product"
    [lang]="lang"
    [link]="product.link"
    (renderLinkEvent)="onProductLinkClick(product)">
    @if (product.media?.type?.toLowerCase() === 'image') {
      @if (getProductImageData(product); as imageData) {
        <img
          alt="{{ getProductDescription(product) ?? '' }}"
          [lazySrc]="imageData" />
      }
    }
    @if (product.media?.type?.toLowerCase() === 'video') {
      <render-video
        [title]="getProductDescription(product) ?? ''"
        [controls]="true"
        [ariaLabel]="getProductDescription(product) ?? ''"
        [loop]="settings?.general?.loop || false"
        [poster]="getProductImageData(product)"
        [muted]="true"
        [autoPlay]="true"
        [clickable]="false"
        [source]="product.media?.urls?.original"
        hudsonStyle="mosaic">
      </render-video>
    }
    @if (product.user_name && settings?.general?.showUserName) {
      <div
        class="product-card-name"
        role="heading"
        aria-level="3">
        <render-wysiwyg
          [html]="direction !== 'rtl' ? '@' + product.user_name : product.user_name + '@'"
          [country]="country"
          [lang]="lang"
          [piece]="piece">
        </render-wysiwyg>
      </div>
    }
  </render-link>
</ng-template>
